import BootstrapButton from "react-bootstrap/Button";
import React from "react";

interface ButtonProps {
  title: string;
  svg?: React.ReactNode;
  onClick?: (e: any) => void;
  className?: string;
  style?: any;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  svg,
  title,
  onClick,
  className,
  style,
  disabled = false,
}) => {
  return (
    <BootstrapButton
      className={`mainButton ${className}`}
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {svg}
      {title}
    </BootstrapButton>
  );
};

export default Button;
